import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { AppConfigService } from "src/app/services/app-config.service";
import { TipoStrumentoAttuativo } from '../models';




@Injectable({
    providedIn: "root"
})
export class TipoStrumentoAttuativoService {
    private apiUrl = `${AppConfigService.env.api_endpoint}${AppConfigService.env.endpoints.inframob}TipiStrumentoAttuativo/`;
    constructor(private http: HttpClient) { }

    getAllDt(dataTablesParameters: any) {
        return this.http.post<any>(
            `${this.apiUrl}alldt`,
            dataTablesParameters
        );
    }
    getAll() {
        return this.http.get<TipoStrumentoAttuativo[]>(
            `${this.apiUrl}`            
        );
    }

    insert(s: TipoStrumentoAttuativo) {
        return this.http.post<any>(`${this.apiUrl}`, s);
    }
    update(s: TipoStrumentoAttuativo) {
        return this.http.put<any>(`${this.apiUrl}${s.id}`, s);
    }
    delete(id: number) {
        return this.http.delete<any>(`${this.apiUrl}${id}`);
    }
    save(s:TipoStrumentoAttuativo){
        if (!s.id)return this.insert(s);
        return this.update(s);
    }

}
